// extracted by mini-css-extract-plugin
export default {"container":"styles_container__UOUxB","fullView":"styles_fullView__QuLYm","shimmer":"styles_shimmer__lkvn+"};